// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ux-z","tooltipWrapper":"vx-z","icon":"wx-z","tooltip":"xx-z","content":"yx-z"};